import { render, staticRenderFns } from "./general-section.vue?vue&type=template&id=642ab746&scoped=true&"
import script from "./general-section.vue?vue&type=script&lang=js&"
export * from "./general-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ab746",
  null
  
)

export default component.exports